/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_CodeInputs */

const de__field_code = /** @type {(inputs: _Field_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token`)
};

/**

* @param {_Field_CodeInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_code = /** @type {((inputs?: _Field_CodeInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_CodeInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_code(inputs)
});